import _ from 'lodash'

import i18n from '@/i18n/i18n'
import PurchaseService from '@/services/admin/PurchaseService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  details: null,
  detail: {}
}

export const mutations = {
  SET_DETAILS(state, details) {
    state.details = details.data
  },
  SET_DETAIL(state, detail) {
    state.detail = detail
  },
  ADD_DETAIL(state, detail) {
    detail.forEach(item => {
      state.details.push(item)
    })
  },
  DELETE_DETAIL(state, id) {
    state.details = _.reject(state.details, item => {
      return item.id === id
    })
  }
}

export const getters = {
  getDetailById: state => id => {
    return state.details ? state.details.find(detail => detail.id === id) : false
  }
}

export const actions = {
  getDetails({ commit, dispatch, state }, purchasePeriodId) {
    if (state.details && state.details[0]?.purchase_period_id === purchasePeriodId) {
      return state.details
    }

    return new Promise((resolve, reject) => {
      PurchaseService.getDetails(purchasePeriodId)
        .then(response => {
          commit('SET_DETAILS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase_details.get_details_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createDetail({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.createDetail(params.period_id, params.details)
        .then(response => {
          commit('ADD_DETAIL', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase_details.create_detail_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteDetail({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.deleteDetail(params.purchase_period_id, params.id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.purchase_details.delete_detail_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('DELETE_DETAIL', params.id)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase_details.delete_detail_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
